<div class="small-empty">
    <div class="page-filters m-4">
        <div class="sort-item">
            <span class="count-page">
                <span>{{recordsData?.data?.total}}</span> {{ "companyProfile.Subscriptions" | translate }}
            </span>

            <span class="sort-selection">
                <label for="">{{ 'general.Sorted by' | translate }}:</label>
                <select class="form-control" (change)="getAll(null)" [(ngModel)]="currentSortSelection"
                    (ngModelChange)="OnSelectSortType()">
                    <option *ngFor="let sortItem of sortItems" [value]="sortItem.value">{{sortItem.name | translate}}
                    </option>
                </select>
            </span>
        </div>
        <div class="filters-container">
            <div class="search-input">
                <input *ngIf="showSearch" autocomplete="off" autofocus maxlength="20" [(ngModel)]="filterModel.search"
                    (keydown.enter)="makeSearch()">
                <button mat-icon-button *ngIf="!showSearch" (click)="makeSearch()">
                    <img src="./assets/images/icons/search.svg">
                </button>
                <button *ngIf="showSearch" mat-icon-button (click)="resetSearch(); showSearch = false;">
                    <img src="./assets/images/icons/ic_close.svg">
                </button>
            </div>


            <!-- <button (click)="showFilter = !showFilter" [ngClass]='{"active": showFilter}' class="btn dropdown-custom font-14">
                <img src="./assets/images/icons/filter.svg">
                <span class="font-14 fontMedium">{{"general.Filter" | translate}}</span>
                <svg width="8" height="5.001" viewBox="0 0 8 5.001">
                    <path id="menu-icon" d="M-3.562-9.316-.5-6.215l3.062-3.1.938.949-4,4.051-4-4.051Z"
                        transform="translate(4.5 9.316)" fill="#6a6a6a" opacity="0.8" />
                </svg>
            </button> -->
        </div>

        <div class="filter-section" [hidden]="!showFilter">
            <h4 class="title">{{"general.Filter by" | translate}}</h4>
            <div class="row">
                <div class="col-lg-6 mb-3">
                    <mat-form-field appearance="fill" class="w-100" [class.loading-field]="packagesLoading">
                        <mat-label>{{'companyProfile.Select Package' | translate}}</mat-label>
                        <mat-select [(ngModel)]="filterModel.package_id">
                            <!-- <mat-option>{{'general.None' | translate}}</mat-option> -->
                            <mat-option [value]="package.id" *ngFor="let package of packages"
                                class="font-16">{{package.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="btn-container">
                <button mat-stroked-button class="btn-primary" (click)="getAll(true)">{{"general.Apply Filter" |
                    translate}}</button>
                <button mat-stroked-button (click)="filterModel.package_id = ''; getAll(true)">{{"general.Clear Filter"
                    | translate}}</button>
            </div>
        </div>
    </div>
    <div *ngIf='dataLoading' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <ng-container *ngIf='!dataLoading'>
        <div *ngIf="recordsData?.data?.list && recordsData?.data?.list?.length; else dataEmpty">
            <div class="table-responsive table-container">
                <table class="table table-primary">
                    <thead>
                        <tr>
                            <th>{{ 'companies.Package (Subscription plan)' | translate }}</th>
                            <th>{{ 'companyProfile.remainingEmployees' | translate }}</th>
                            <th>{{ 'companyProfile.subscription start date' | translate }}</th>
                            <th>{{ 'companyProfile.subscription end date' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of recordsData?.data?.list">
                            <td>
                                <p class="m-0 font-18 fontRegular d-flex align-items-center">{{item.name_ar}}
                                    <span class="status-badge green font-11 mx-2" *ngIf="item.is_current">
                                        {{'companyProfile.Current package' | translate}}
                                    </span>
                                </p>
                                <p class="m-0">{{item.name_en}}</p>
                            </td>
                            <td class="font-16 fontRegular grey-color text-nowrap">
                                @if (item.is_current) {
                                {{item.remaining_number | number}}
                                {{"Departments.Employee"|translate}}
                                }
                                @else {
                                    -
                                }
                            </td>
                            <td class="font-16 fontRegular grey-color text-nowrap">
                                {{item.start_date | date :'d MMMM y'}}
                            </td>
                            <td class="font-16 fontRegular grey-color text-nowrap">
                                {{item.end_date | date :'d MMMM y'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="pagination-container" *ngIf="recordsData!.data.total > 10">
                <mat-paginator [selectConfig]="{disableOptionCentering: true}" [length]="recordsData!.data.total"
                    [pageSize]="pageSize" (page)="getAll($event)" [pageSizeOptions]="[10, 20, 50, 100]"
                    [pageIndex]="pageIndex"></mat-paginator>
            </div>
        </div>
        <ng-template #dataEmpty>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
        </ng-template>
    </ng-container>
</div>